// TODO: este componente no tiene sentido. No tiene suficiente contenido para justificar su existencia.
function GuarantyInfo({ infoText }: { infoText: string }) {
  return <li className="mb-4 block last:mb-1.5 lab:mb-0" dangerouslySetInnerHTML={{ __html: infoText }} />;
}

export default GuarantyInfo;
